import { Injectable, signal, TemplateRef } from '@angular/core';

/**
 * A service to manage the content of the sub-navbar component.
 * This service is used to dynamically append content to the sub-navbar component.
 */
@Injectable({
    providedIn: 'root',
})
export class SubNavbarService {
    private _content = signal<TemplateRef<any> | null>(null);
    public content = this._content.asReadonly();

    private _hideDate = signal<boolean>(false);
    public hideDate = this._hideDate.asReadonly();

    /**
     * Sets the content of the sub-navbar component.
     * @param content The template reference to be displayed in the sub-navbar component.
     */
    public setContent<T>(content: TemplateRef<T>) {
        this._content.set(content);
    }

    /**
     * Clears the content of the sub-navbar component.
     */
    public clearContent() {
        this._content.set(null);
    }

    /**
     * Sets whether to hide the date in the sub-navbar.
     * @param hide Boolean flag to hide or show the date
     */
    public setHideDate(hide: boolean) {
        this._hideDate.set(hide);
    }
}
